const currencyFormatter = new Intl.NumberFormat("en-US", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const compactFormatter = new Intl.NumberFormat("en-US", {
	notation: "compact",
	maximumFractionDigits: 1,
});

/** "1,234.56" */
export const formatAmount = (value: number | string): string =>
	currencyFormatter.format(Number(value));

/** "$1,234.56" */
export const formatUsd = (value: number | string): string =>
	`$${formatAmount(value)}`;

/** "+$1,234.56" / "-$1,234.56" */
export const formatUsdSigned = (value: number | string): string => {
	const n = Number(value);
	const formatted = formatAmount(Math.abs(n));
	return n >= 0 ? `+$${formatted}` : `-$${formatted}`;
};

/** Fixed-width privacy mask — its length never leaks the balance magnitude. */
export const MASKED_BALANCE = "$•••••";

/** formatUsd, or the privacy mask when balances are hidden. */
export const formatUsdPrivate = (value: number | string, hidden: boolean): string =>
	hidden ? MASKED_BALANCE : formatUsd(value);

/** "$10.5K" for >= 10 000, otherwise "$1,234.56" */
export const formatUsdCompact = (value: number | string): string => {
	const n = Number(value);
	return n >= 10_000 ? `$${compactFormatter.format(n)}` : formatUsd(n);
};

const cryptoFormatter = new Intl.NumberFormat("en-US", {
	maximumFractionDigits: 8,
});

/** "50 USDT" / "0.0015 BTC" (trailing zeros trimmed) */
export const formatCrypto = (value: number | string, currency: string): string =>
	`${cryptoFormatter.format(Number(value))} ${currency}`;

/** Fraction → percent: "0.035" → "3.5%" (trailing zeros trimmed). */
export const formatPercent = (value: number | string): string => {
	const pct = Number(value) * 100;
	return `${Number(pct.toFixed(4))}%`;
};
